// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Y0Yq","alert":"SettungsInbox_alert__3d5GK"};